import { isDev, apiUrl } from "core/constants";

export const baseUrl = apiUrl
  ? apiUrl
  : isDev
  ? "http://localhost:8010/proxy/"
  : "https://api.azure-test.wsai.nortal.com/";

export const portalCode = "BP";
